export default "__VITE_ASSET__Ddy1cT4p__"